import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { VesselClassPayload, VesselClassResponse } from "@/types/interface/vessel-class";

async function createVesselClass(payload: VesselClassPayload) {
  return await http.post<APIResponse<VesselClassResponse>>("vessel-class/create", payload);
}

async function updateVesselClass(idVeselType = '', payload: VesselClassPayload) {
  return await http.patch<APIResponse<VesselClassResponse>>(`vessel-class/update?id=${idVeselType}`, payload);
}

async function getVesselClass(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
  return await http.get<APIResponse<VesselClassResponse>>(`vessel-class?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function findVesselClass(idVeselType = "") {
  return await http.get<APIResponse<VesselClassResponse>>(`vessel-class/detail?id=${idVeselType}`);
}

async function deleteVesselClass(idVeselType = "") {
  return await http.delete<APIResponse<VesselClassResponse>>(`vessel-class/delete?id=${idVeselType}`);
}

export default {
  createVesselClass,
  updateVesselClass,
  getVesselClass,
  findVesselClass,
  deleteVesselClass
};